module.exports = __webpack_public_path__ + "media/images/pla/pla10-98327e5b26c89f0a88bf0fdde2d0f33f.jpg";